import React from 'react';
import { useTranslation } from 'react-i18next';
import TextPageWrapper from '..';
import { Typography } from '@mui/material';
export default function UserAcknowledgmentPage() {
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(TextPageWrapper, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h2"
  }, t('general.user_acknowledgment')), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('general.user_acknowledgment_body')));
}